export default function CategoryCard({ category, onClick }) {
    const isPortrait = category.orientation === "portrait";

    return (
        <div
            onClick={onClick}
            className={`
        relative cursor-pointer overflow-hidden rounded-3xl group
        ${isPortrait
                ? "w-[45vh] h-[65vh]"     // Tall portrait card
                : "w-[65vw] h-[65vh]"     // Wide landscape card
            }
      `}
        >
            <img
                src={category.coverImage}
                alt={category.title}
                className="absolute inset-0 w-full h-full object-cover transition duration-700 group-hover:scale-105"
            />


            <div className="absolute bottom-10 left-8 text-white">
                <h3 className="text-3xl font-semibold tracking-tight">
                    {category.title}
                </h3>
                <p className="mt-3 text-white/70 max-w-sm">
                    {category.description}
                </p>
            </div>
        </div>
    );
}